// extracted by mini-css-extract-plugin
export default {"stopItems":"stopList_stopItems__gYjtF"};